// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCXFJw9HvdQozJFd6mdoMUxARFl_rKW9fQ",
  authDomain: "aigent-cb90a.firebaseapp.com",
  projectId: "aigent-cb90a",
  storageBucket: "aigent-cb90a.appspot.com",
  messagingSenderId: "100406747328",
  appId: "1:100406747328:web:c8c76d823ea41dd461cd25",
  measurementId: "G-2F40L6S4GX"
};

export default firebaseConfig;
